module.exports = __webpack_public_path__ + "img/FlipCameraIosOutlined.1370d46d.svg";